import { Platform, environment } from "src/index";
export const platform: Platform = {
    ...environment,
    platform: 'web',
};